import { inject, Injectable } from "@angular/core";
import { routes } from "src/app/routing/routes";
import { TabService } from "src/app/services/tab.service";

@Injectable()
export class MentionService {
  static MARKER_CUSTOMER_PATIENT = "#";

  readonly #tabService = inject(TabService);

  async processClick({
    clickEvent,
    containerElement
  }: {
    clickEvent: MouseEvent;
    containerElement: HTMLElement;
  }): Promise<void> {
    const elements = traverseAndStopOnContainerElement(
      clickEvent,
      containerElement
    );

    const elementWithMention = elements.find((element: Element) => {
      return element.classList.contains("dx-mention");
    });

    if (elementWithMention) {
      clickEvent.stopImmediatePropagation();
      clickEvent.preventDefault();

      const marker = elementWithMention.attributes.getNamedItem("data-marker");
      const id = elementWithMention.attributes.getNamedItem("data-id");

      switch (marker?.value) {
        case MentionService.MARKER_CUSTOMER_PATIENT: {
          if (id?.value) {
            const mentionType = <"customer" | "patient">id.value.split("-")[0];
            const mentionValue: string = id.value.split("-")[1];

            switch (mentionType) {
              case "customer": {
                await this.#tabService.open(
                  routes.organization.customers_registry.id(mentionValue)
                );
                break;
              }
              case "patient": {
                await this.#tabService.open(
                  routes.organization.patients_registry.id(mentionValue)
                );
                break;
              }
            }
          }
          break;
        }
      }
    }
  }
}

function traverseAndStopOnContainerElement(
  clickEvent: MouseEvent,
  containerElement: HTMLElement
): Element[] {
  return clickEvent.target
    ? traverseToTop(<Element>clickEvent.target, containerElement, [])
    : [];
}

function traverseToTop(
  startElement: Element,
  stopElement: Element,
  elements: Element[]
): Element[] {
  if (startElement === stopElement) {
    return elements;
  }

  if (startElement.parentElement) {
    elements.push(startElement);
    traverseToTop(startElement.parentElement, stopElement, elements);
  }

  return elements;
}
